<template>
  <div class="whole">
    <div class="search">
      <el-form :inline="true">
        <el-form-item>
          <el-button v-popover:popover1 class="el-icon-plus" type="primary">{{ $t("button.Add the information of Country") }}</el-button>
        </el-form-item>
        <!--   添加国家的弹窗     -->
        <el-popover
            ref="popover1"
            border
            placement="bottom"
            trigger="click"
            width="680">
          <el-form :inline="true">
            <el-form-item>
              <el-select v-if="isLanguage" v-model="addContinentValue1" :placeholder="$t('placeholder.Continent')">
                <el-option
                    v-for="item in optionsContinent"
                    :key="item.id"
                    :label="item.name_cn"
                    :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-select v-if="!isLanguage" v-model="addContinentValue1" :placeholder="$t('placeholder.Continent')">
                <el-option
                    v-for="item in optionsContinent"
                    :key="item.id"
                    :label="item.name_en"
                    :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-input v-model="addCountryValue1" :placeholder="$t('placeholder.Country1CN')"></el-input>
            </el-form-item>

            <el-form-item>
              <el-input v-model="addCountryValue1EN" :placeholder="$t('placeholder.Country1EN')"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="addCountry(addContinentValue1,addCountryValue1,addCountryValue1EN)">{{ $t("button.Add") }}</el-button>
            </el-form-item>
          </el-form>
        </el-popover>
        <!--   end     -->

        <el-form-item>
          <el-button v-popover:popover2 class="el-icon-plus" type="primary">{{ $t("button.Add the information of City") }}</el-button>
        </el-form-item>
        <!--   添加城市的弹窗     -->
        <el-popover
            ref="popover2"
            border
            placement="bottom"
            trigger="click"
            width="890">
          <el-form :inline="true">
            <el-form-item>
              <el-select v-if="isLanguage" v-model="addContinentValue2" :placeholder="$t('placeholder.Continent')" @change="getCountry(addContinentValue2)">
                <el-option
                    v-for="item in optionsContinent"
                    :key="item.id"
                    :label="item.name_cn"
                    :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-select v-if="!isLanguage" v-model="addContinentValue2" :placeholder="$t('placeholder.Continent')" @change="getCountry(addContinentValue2)">
                <el-option
                    v-for="item in optionsContinent"
                    :key="item.id"
                    :label="item.name_en"
                    :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-select v-if="isLanguage" v-model="addCountryValue2" :placeholder="$t('placeholder.Country')">
                <el-option
                    v-for="item in optionsCountry"
                    :key="item.id"
                    :label="item.name_cn"
                    :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-select v-if="!isLanguage" v-model="addCountryValue2" :placeholder="$t('placeholder.Country')">
                <el-option
                    v-for="item in optionsCountry"
                    :key="item.id"
                    :label="item.name_en"
                    :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-input v-model="addCityValue" :placeholder="$t('placeholder.City5CN')"></el-input>
            </el-form-item>

            <el-form-item>
              <el-input v-model="addCityValueEN" :placeholder="$t('placeholder.City5EN')"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="addCity(addCountryValue2,addCityValue,addCityValueEN)">{{ $t("button.Add") }}</el-button>
            </el-form-item>
          </el-form>
        </el-popover>
        <!--   end     -->

        <el-form-item>
          <el-select v-if="isLanguage" v-model="continentValue" :placeholder="$t('placeholder.Continent')" @change="getCountry(continentValue)" style="width: 150px;">
            <el-option
                v-for="item in optionsContinent"
                :key="item.id"
                :label="item.name_cn"
                :value="item.id">
            </el-option>
          </el-select>
          <el-select v-if="!isLanguage" v-model="continentValue" :placeholder="$t('placeholder.Continent')" @change="getCountry(continentValue)" style="width: 150px;">
            <el-option
                v-for="item in optionsContinent"
                :key="item.id"
                :label="item.name_en"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-select v-if="isLanguage" v-model="countryValue" :placeholder="$t('placeholder.Country')" @change="getCity(countryValue)" style="width: 150px;">
            <el-option
                v-for="item in optionsCountry"
                :key="item.id"
                :label="item.name_cn"
                :value="item.id">
            </el-option>
          </el-select>
          <el-select v-if="!isLanguage" v-model="countryValue" :placeholder="$t('placeholder.Country')" @change="getCity(countryValue)" style="width: 150px;">
            <el-option
                v-for="item in optionsCountry"
                :key="item.id"
                :label="item.name_en"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-select v-if="isLanguage" v-model="cityValue" clearable :placeholder="$t('placeholder.City3')" style="width: 150px;">
            <el-option
                v-for="item in optionsCity"
                :key="item.id"
                :label="item.name_cn"
                :value="item.id">
            </el-option>
          </el-select>
          <el-select v-if="!isLanguage" v-model="cityValue" clearable :placeholder="$t('placeholder.City3')" style="width: 150px;">
            <el-option
                v-for="item in optionsCity"
                :key="item.id"
                :label="item.name_en"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button class="el-icon-search" type="primary" @click="search(continentValue,countryValue,cityValue)">{{$t("button.Search")}}</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="table">
      <el-table
          v-if="refresh"
          :cell-style="{'text-align':'center'}"
          :data="cityData.slice((currentPage-1)*pagesize,currentPage*pagesize)"
          :header-cell-style="{'text-align':'center'}"
          border
          style="width: 100%">

        <el-table-column :label="$t('label.Continent-1')" prop="continent">
          <template v-slot="scope">
<!--            <input v-show="scope.row.iseditor" v-model="scope.row.continent" type="text"/>-->
            <span>{{scope.row.continent}}</span>
          </template>
        </el-table-column>

<!--Country start-->
        <el-table-column v-if="isLanguage" :label="$t('label.Country-1')" prop="countrynamecn">
          <template v-slot="scope">
            <el-select v-show="scope.row.iseditor" v-model="scope.row.countrynamecn">
              <el-option
                  v-for="item in optionsCountryChange"
                  :key="item.id"
                  :label="item.name_cn"
                  :value="item.name_cn">
              </el-option>
            </el-select>
            <span v-show="!scope.row.iseditor">{{scope.row.countrynamecn}}</span>
          </template>
        </el-table-column>

        <el-table-column v-if="!isLanguage" :label="$t('label.Country-1')" prop="countrynameen">
          <template v-slot="scope">
            <el-select v-show="scope.row.iseditor" v-model="scope.row.countrynamecn">
              <el-option
                  v-for="item in optionsCountryChange"
                  :key="item.id"
                  :label="item.name_en"
                  :value="item.id">
              </el-option>
            </el-select>
            <span v-show="!scope.row.iseditor">{{scope.row.countrynameen}}</span>
          </template>
        </el-table-column>
<!--Country end-->
        <el-table-column :label="$t('label.CityNameCN')" prop="citynamecn">
          <template v-slot="scope">
            <input v-show="scope.row.iseditor" v-model="scope.row.citynamecn" type="text"/>
            <span v-show="!scope.row.iseditor">{{scope.row.citynamecn}}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('label.CityNameEN')" prop="citynameen">
          <template v-slot="scope">
            <input v-show="scope.row.iseditor" v-model="scope.row.citynameen" type="text"/>
            <span v-show="!scope.row.iseditor">{{scope.row.citynameen}}</span>
          </template>
        </el-table-column>

        <el-table-column fixed="right" :label="$t('label.Operation')">
          <template v-slot="scope">
            <el-button class="el-icon-edit"  size="small" type="text" @click="edit(scope.row)">{{ $t("button.Edit") }}</el-button>
            <el-button class="el-icon-check" size="small" type="text" @click="save(scope.row)">{{ $t("button.Save") }}</el-button>
            <el-button class="el-icon-delete" size="small" type="text" @click="handleDelete(scope.row)">{{ $t("button.Delete") }}</el-button>
          </template>
        </el-table-column>

        <template slot="empty">
          <p>{{$t("label.empty")}}</p>
        </template>
      </el-table>
    </div>

    <div class="pagination">
      <el-pagination
          :page-size="pagesize"
          :total="cityData.length"
          background
          layout="prev, pager, next"
          @current-change="current_change">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
export default {
  name: "cityManage",
  data() {
    return {
      confirmButtonText:'',
      cancelButtonText:'',
      confirmMessage:'',
      confirmMessage1:'',
      Message1:'',
      title:'',
      isLanguage:'',
      refresh:true,//保证表格刷新的变量
      addContinentValue1:'',//"添加国家按钮"--要添加国家的所属洲
      addCountryValue1:'',//"添加国家按钮"--要添加国家的值
      addCountryValue1EN:'',

      addContinentValue2:'',//"添加城市按钮"--要添加城市的所属洲
      addCountryValue2:'',//"添加城市按钮"--要添加城市的所属国家
      addCityValue:'',//"添加城市按钮"--要添加城市的值
      addCityValueEN:'',

      cityData:[],//存储搜索后数据的列表
      optionsContinent: [],//"洲"下拉列表
      optionsCountry: [],//"国家"下拉列表
      optionsCity:[],//"城市"下拉列表
      optionsCountryChange:[],

      continentValue:'',//选中洲的值
      countryValue:'',//选中国家的值
      cityValue:'',//选中城市的值

      pagesize:6,//每页的数据条数
      currentPage:1,//默认开始页面
    }
  },
  methods: {
    //监测当前页面
    current_change:function(currentPage){
      this.currentPage = currentPage;
    },
    //获取洲的数据
    getContinent(){
      request.get('/continent').then(result => {
        this.optionsContinent = result.data
      }).catch(err => {
        console.log(err)
      })
    },
    //获取国家的数据
    getCountry(continentValue){
      request.get('/country?continent_id='+continentValue).then(result => {
        this.optionsCountry=result.data
      }).catch(err => {
        console.log(err)
      })
    },
    //获取城市的数据
    getCity(countryValue){
      request.get('city?country_id='+countryValue).then(result => {
        this.optionsCity=result.data
      }).catch(err => {
        console.log(err)
      })
    },
    //实现搜索按钮
    async search(continentValue,countryValue,cityValue){
      this.cityData=[]
      var flag=true
      var continent
      //情况1：洲的值为空，不符合搜索条件
      //记录当前选中的洲
      if(continentValue==''){
        flag=false
        if(this.isLanguage===true){alert("请输入洲的值")}
        else{alert("Please input the continent value")}
      }else{
        await request.get('/continent/'+continentValue).then(result => {
          if(this.isLanguage===true){
            continent=result.data.name_cn
          }
          else{
            continent=result.data.name_en
          }
        }).catch(err => {
          console.log(err)
        })
      }
      //情况2：国家的值为空，不符合搜索条件
      if(countryValue==='' && flag===true){
        flag=false
        if(this.isLanguage===true){alert("请输入国家的值")}
        else{alert("Please input the country value")}
      }
      //情况3：有城市的值，进行搜索
      if(cityValue.length!==0 && flag===true){
        request.get('/city/'+cityValue).then(result => {
          var e={}
          var dict={}
          e = result.data
          dict.continent=continent
          dict.cityid=e.id
          dict.citynamecn=e.name_cn
          dict.citynameen=e.name_en
          dict.countryid=e.country.id
          dict.countrynamecn=e.country.name_cn
          dict.countrynameen=e.country.name_en
          dict.iseditor=false
          this.cityData.push(dict)
        }).catch(err => {
          console.log(err)
        })
      }
      //情况4：没有城市的值，进行搜索
      if(cityValue.length===0 && flag===true){
        request.get('/city').then(result => {
          var temp4=[]
          var newList4=[]
          var dict1={}
          temp4 = result.data
          temp4.forEach(function (e) {
            if(e.country.id===countryValue){
              dict1={}
              dict1.continent=continent
              dict1.cityid=e.id
              dict1.citynamecn=e.name_cn
              dict1.citynameen=e.name_en
              dict1.countryid=e.country.id
              dict1.countrynamecn=e.country.name_cn
              dict1.countrynameen=e.country.name_en
              dict1.iseditor=false
              newList4.push(dict1)
            }
          })
          this.cityData=newList4
        }).catch(err => {
          console.log(err)
        })
      }
      request.get('/country?continent_id='+continentValue).then(result => {
        this.optionsCountryChange=result.data
      }).catch(err => {
        console.log(err)
      })
    },
    //编辑此行数据信息
    edit(row) {
      row.iseditor =true;
    },
    //保存修改后的数据信息，上传至数据库
    save(row) {
      var changeCountryId
      request('/country?name_cn='+ row.countrynamecn).then(response =>{
        changeCountryId = response.data[0].id
      })
      var that = this;
      row.iseditor = false;
      this.$confirm(this.confirmMessage, this.title, {
        confirmButtonText:this.confirmButtonText,
        cancelButtonText: this.cancelButtonText,
        type: 'warning'
      }).then(() => {
        request.put("/city?country_id="+ changeCountryId +"&id="+ row.cityid + "&name_cn=" + row.citynamecn + "&name_en="+row.citynameen ).then(response => {
          if (response.data === true) {
            that.countryValue = row.countrynamecn
            that.getCountry(that.continentValue)
            that.getCity(that.countryValue)
            that.search(that.continentValue,that.countryValue,that.cityValue)
            that.$forceUpdate();
            if(this.isLanguage===true){
              that.cityValue = row.citynamecn
              alert("城市信息修改成功！")
            }
            else{
              that.cityValue = row.citynameen
              alert("City information modified successfully！")
            }
          } else {
            if(this.isLanguage===true){
              alert("数据信息修改失败！")
            }
            else{
              alert("Failed to modify data information！")
            }
            this.search(this.continentValue,this.countryValue,this.cityValue)
          }
        }).catch(err => {
          if(this.isLanguage===true){
            alert("申请修改失败，请稍后重试！");
          }
          else{
            alert("Failed to apply for modification, please try again later!")
          }
          console.log(err);
        })
      })
    },
    //删除此行数据信息
    handleDelete(row) {
      var that = this;
      this.$confirm(this.confirmMessage1, this.title, {
        confirmButtonText: this.confirmButtonText,
        cancelButtonText: this.cancelButtonText,
        type: 'warning'
      }).then(() => {
        request.delete("/city/"+row.cityid).then(response => {
          if (response.data === true) {
            that.getCountry(that.continentValue)
            that.getCity(that.countryValue)
            that.search(that.continentValue,that.countryValue,'')
            that.$forceUpdate();
            if(this.isLanguage===true){
              that.cityValue = ''
              alert("数据删除成功！")
            }
            else{
              that.cityValue = ''
              alert("Delete successfully！")
            }
            //删除成功，再次提交search函数
            //根据数据监听函数，刷新table组件
            // this.search(this.continentValue,this.countryValue,'')
          } else {
            if(this.isLanguage===true){
              alert("数据删除失败！")
            }
            else{
              alert("Failed to delete！")
            }
          }
        }).catch(err => {
          if(this.isLanguage===true){
            alert("申请修改失败，请稍后重试！");
          }
          else{
            alert("Failed to apply for modification, please try again later!")
          }
          console.log(err);
        })
      }
      ).catch(() => {
        this.$message({
          type: 'info',
          message: this.Message1
        })
      })
    },
    //增加国家
    addCountry(addContinentValue1,addCountryValue1,addCountryValue1EN){
      var that=this
      var countryDic={
        "continent": {"id":0},
        // "name_cn":'',
        // "name_en":''
      }
      countryDic.continent.id=addContinentValue1
      countryDic.name_cn=addCountryValue1
      countryDic.name_en=addCountryValue1EN
      request.post('/country',countryDic).then(function (result){
        if(result.data===true){
          // that.getCountry(that.continentValue)
          // that.getCity(that.countryValue)
          // that.search(that.continentValue,that.countryValue,that.cityValue)
          that.continentValue = ''
          that.countryValue = ''
          that.cityValue = ''
          that.$forceUpdate();
          if(that.isLanguage===true){
            alert("添加国家成功！")
          }
          else{
            alert("Country added successfully!")
          }
        }
        else{
          if(that.isLanguage===true){alert("添加国家失败！已存在该数据")}
          else{alert("Failed to add country! The country information already exists")}
        }
      })
      that.addContinentValue1=''
      that.addCountryValue1=''
      that.addCountryValue1EN=''
    },
    // 增加城市
    addCity(addCountryValue2,addCityValue,addCityValueEN){
      var that=this
      request.post('/city?country_id='+addCountryValue2+'&name_cn='+addCityValue+'&name_en='+addCityValueEN).then(function (result){
        if(result.data===true){
          // that.getCountry(that.continentValue)
          // that.getCity(that.countryValue)
          // that.search(that.continentValue,that.countryValue,that.cityValue)
          that.continentValue = ''
          that.countryValue = ''
          that.cityValue = ''
          that.$forceUpdate();
          if(that.isLanguage===true){alert("添加城市成功！")}
          else{alert("City added successfully!")}
          that.addContinentValue2=''
          that.addCountryValue2=''
          that.addCityValue=''
          that.addCityValueEN=''
        }
        else{
          if(that.isLanguage===true){alert("添加城市失败！已存在该数据")}
          else{alert("Failed to add city! The city information already exists")}
        }
      })
    }
  },
  //监听表格数据的改变
  watch:{
    cityData:{
      handler(){
        this.refresh=false
        this.$nextTick(()=>{
          this.refresh=true
        })
      }
    }
  },
  created() {
    this.getContinent();
    if(this.$i18n.locale==='cn'){
      this.isLanguage=true
      this.confirmButtonText='确定'
      this.cancelButtonText='取消'
      this.confirmMessage='此操作将修改该数据'
      this.confirmMessage1='此操作将永久删除此数据，是否要继续？'
      this.Message1='已取消删除'
      this.title='提示'
    }
    else{
      this.isLanguage=false
      this.confirmButtonText='Confirm'
      this.cancelButtonText='Cancel'
      this.confirmMessage='This operation will modify the data'
      this.confirmMessage1='This operation will permanently delete this data. Do you want to continue?'
      this.Message1='Deletion cancelled'
      this.title='tip'
    }
  }
}
</script>

<style>
  @import "~@/assets/css/sameCss.css";
</style>